import { render, staticRenderFns } from "./tab11.vue?vue&type=template&id=202fc3ab"
import script from "./tab11.vue?vue&type=script&lang=js"
export * from "./tab11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202fc3ab')) {
      api.createRecord('202fc3ab', component.options)
    } else {
      api.reload('202fc3ab', component.options)
    }
    module.hot.accept("./tab11.vue?vue&type=template&id=202fc3ab", function () {
      api.rerender('202fc3ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab11.vue"
export default component.exports